// extracted by mini-css-extract-plugin
export default {"container":"tinder_container__1Z9qp","inner":"tinder_inner__3cDmL","button":"tinder_button__2bk0o","content":"tinder_content__3usAr"};